import { useQuery } from '@tanstack/react-query';
import type { ViewDateSourceDTO } from '@tempo-io/roadmap-dto';
import { DateSourceApi } from '@/lib/api/loop-visualization/date-source';
import { ONE_HOUR_IN_MS } from '@/lib/constants';
import { viewQueryKeys } from '@/lib/query-keys/view';

const PLAN_DATE_SOURCE = (viewId: number): ViewDateSourceDTO => ({
  viewId,
  dateSourceType: 'PLAN',
  startCustomFieldId: null,
  finishCustomFieldId: null,
});

export const useViewDateSource = (viewId: number, options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: viewQueryKeys.dateSource.detail(viewId),
    queryFn: () => DateSourceApi.fetchDateSource(viewId),
    staleTime: ONE_HOUR_IN_MS,
    placeholderData: PLAN_DATE_SOURCE(viewId),
    enabled: options?.enabled,
  });
